

export default function faqModal() {

  return (
    <>


    <div id="exampleModal" class="modal" tabindex="-1" role="dialog">
        <div class=" modal-dialog-scrollable modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">FAQ</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">

      <h2>Overall</h2>
      <p>The buying, selling, and mining of jellybeans crates an interesting environment. It should be looked as a higher risk strategy where users grow there number of beans which can be sold for the native Currency which has been pooled. </p>

      <h2>0: can bean value go down</h2>
      <p>yes. Beans are pegged to BNB, AVAX, or ETC so if there is less native Currency in the contract then the value will go down.</p>

      <h2> 1: What happens when I bag jellybeans</h2>
      <p>When you buy Beans, the Currency you used ( BNB, AVAX, or ETC ) gets locked into the jellybeanbag smart contract and rewards you with up to 8% in jellybeans daily returns every day.</p>

      <h2>2: Can I take my initial coins back?</h2>
     <p>No. Bean vaule is dependent on the pools total value. when beans are sold the pools value goes down when bought they go up.  When you buy "miners" they are mining beans which if u can sell to let u get the respective value in the native chainCurrency or keep getting more beans.  </p>
    
      <h2>3: How much are my fees?</h2> 
     <p> There is a small 3% dev fee in order to pay for  developing the jellybeanbag ecosystem and buy backs</p>

      <h2> 4: How often should I re-bag (compound)?  </h2>
     <p>  Fell free to do so as often as you wish. but there are different strategies that exist. </p>

      <h2> 5: How is jellybeanbag  sustainable?  </h2>
      <p>jellybeanbag is sustained by continued community support, just as every other crypto coin, token or project. The difference is that since there is no token, it is all in the contact.  As long as BNB, AVAX, or ETC is in the contract, beans will be worth something</p>

      <h2>  7: How to use jellybeanbag on my phone?  </h2>
      <p>You can either use an app with a dapp browser and choose the Metamask/Injected option or simply use any browser that you want and choose WalletConnect to connect to your wallet's app on your phone.</p>




            </div>
           
          </div>
        </div>
      </div>

    </>
  );



}
